const {
  REACT_APP_BASEURL,
  REACT_APP_URL_PREFIX,
  REACT_APP_LOGIN_BASE_URL,
  REACT_APP_IAM_URL,
  REACT_APP_PARTNER_URL,
  REACT_APP_NETWORK_URL,
  REACT_APP_AGGREGATOR_URL,
  REACT_APP_GOOGLE_SPREADSHEET_URL,
} = process.env;

export {
  REACT_APP_BASEURL as BASEURL,
  REACT_APP_URL_PREFIX as URL_PREFIX,
  REACT_APP_LOGIN_BASE_URL as LOGIN_BASE_URL,
  REACT_APP_IAM_URL as IAM_URL,
  REACT_APP_PARTNER_URL as PARTNER_URL,
  REACT_APP_NETWORK_URL as NETWORK_URL,
  REACT_APP_AGGREGATOR_URL as AGGREGATOR_URL,
  REACT_APP_GOOGLE_SPREADSHEET_URL as SPREADSHEET_URL,
};
